import * as React from "react";

import {cx} from "emotion";

import {Types}                 from "@Common/types";
import {setNestedValue}        from "@Common/utils/arr-path";
import {equalDeep, filterKeys} from "@Common/utils/objects";

export const makeFieldFactory = <FormModel,>({formState, inputFactory: makeInput}:{
    formState    : Types.Common.React.CsForm.CsFormNext<FormModel>,
    inputFactory : ReturnType<typeof makeInputFactory>,
}):Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.TabFieldFactory<FormModel> => (
    ({disabled, label, path, xdQaName=""}) => {
        const error = formState.field(path).getError()?.getMessage();
        return (
            <div key={path} className={cx("field-row", {bad: !disabled && Boolean(error)})}>
                <label xd-qa-type="label" xd-qa-name={xdQaName + label}>{label}</label>
                {makeInput({disabled, label, path, xdQaName})}
            </div>
        );
    }
);

export const makeInputFactory = <FormModel extends Record<string, string>,>({formState, branch, setHasUnsavedChanges}:{
    formState            : Types.Common.React.CsForm.CsFormNext<FormModel>,
    branch               : Types.Apis.Payloads.Next.Branch.GetById.Response,
    setHasUnsavedChanges : (hasUnsavedChanges:boolean) => void,
}):Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.TabInputFactory<FormModel> => (
    ({disabled, label, path, xdQaName}) => {
        const field = formState.field(path);
        return (
            <input
                disabled={disabled}
                onChange={(e) => {
                    setHasUnsavedChanges(!equalDeep(filterKeys(branch ?? {}, (key) => key in formState.value), setNestedValue(formState.value, [path] as any, e.target.value)));
                    field.onChange(e.target.value as FormModel[typeof path]);
                }}
                value={field.value ?? ""}
                title={field.getError()?.getMessage()}
                className={cx({bad: Boolean(field.getError())})}
                xd-qa-type="text_field"
                xd-qa-name={xdQaName + label}
            />
        );
    }
);

